

import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class CustomerInformationService {

    static getCustomerInformation(CompanyCode, email) {
        //var data = [];
        return axios.get(`${BaseUrl}CustomerInformation?CompanyCode=${CompanyCode ? CompanyCode : ''}&email=${email ? email : ''}`);
    }
}


// WEBPACK FOOTER //
// ./src/Services/CustomerInformationService/customerInformationService.js